import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

/**
 * ConfirmDialog
 * Wrapper em volta do SweetAlert2 para padronizar as confirmações do NeoApp.
 */
const ConfirmDialog = async ({
    title = 'Tem certeza?',
    text = 'Essa ação não poderá ser revertida!',
    icon = 'warning',
    confirmButtonText = 'Sim, excluir!',
    cancelButtonText = 'Cancelar',
    confirmButtonColor = '#dc3545', // Cor Danger padrão
    cancelButtonColor = '#6c757d'   // Cor Secondary padrão
}) => {
    const result = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonColor,
        cancelButtonColor,
        confirmButtonText,
        cancelButtonText,
        customClass: {
            container: 'confirm-dialog-container',
            popup: 'confirm-dialog-popup',
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-secondary ms-2'
        },
        buttonsStyling: false
    });

    return result.isConfirmed;
};

export default ConfirmDialog;
